<template>
	<div id="datfastview" class="viewport">
  	
  	<div id="datFastRequestPopUp" v-bind:class=" { visible: popUpVisible }">
    	<div class="datFastRequestPopUpBox">
        <h3>DAT Schnellabfrage</h3>
        <div class="popUp-vin popUp-inputwrapper">
          <input v-model="datRequestData.vorgangsnummer" id="popUpVorgangsnummer" placeholder="z.B. XXX001">
          <label for="popUpVorgangsnummer">Vorgangsnummer</label>
        </div>
        <div class="popUp-vin popUp-inputwrapper">
          <input v-model="datRequestData.vin" id="popUpVin" placeholder="z.B. WDCDEXTESTSTUB001">
          <label for="popUpVin">VIN</label>
        </div>
        <div class="popUp-baujahr popUp-inputwrapper">
          <input v-model="datRequestData.baujahr" id="popUpBaujahr" placeholder="z.B. 2009">
          <label for="popUpBaujahr">Baujahr</label>
        </div>
        <div class="popUp-laufleistung popUp-inputwrapper">
          <input v-model="datRequestData.laufleistung" id="popUpLaufleistung" placeholder="z.B. 75000">
          <label for="popUpLaufleistung">Laufleistung</label>
        </div>
        <div class="popUp-submit popUp-inputwrapper">
          <button v-on:click="startDatRequest" class="button">DAT jetzt abfragen</button>
          <button v-on:click="closeDatRequest" class="button">Abbrechen</button>
        </div>
    	</div>
  	</div>
  	
		<div class="columns">
			<div class="column">
				<h1>Dat Schnellabfrage</h1>
			</div>
			<div class="column alignRight">
				<button class="button is-pulled-right" v-on:click="newDatRequest">Neue DAT-Abfrage</button>
			</div>
		</div>
		<div class="columns">
			<div class="column">
				<div class="borderround">							
					<dat-fast-request :datrequest.sync="datrequest" :key="datrequest.id" v-for="(datrequest, key, index) in datrequests"></dat-fast-request>
				</div>
			</div>
		</div>
	</div>
</template>
</template>
<script>
import DatFastRequest from '@/components/Dat/DatFastRequest';

import datconfig from './config'
import xml2json from './xml2json'
//import soapRequest from 'easy-soap-request';
import axios from 'axios';
import xml2js from 'xml2js';
import sweetalert from 'sweetalert';


export default {

	name: "DatFastView",
	components: {
     DatFastRequest,
	},
	data() {
	    return {
          DATinfo: false,
          datrequests: [],
          datRequestData: {
            vin: null,
            baujahr: null,
            laufleistung: null,
            vorgangsnummer: 'XXX',
            open: true
          },
          popUpVisible: false,
          popUpButtonHtml: { el: null, text: ''}
      }
  },
  sockets: {
      syncgetDatFastList(r){
      //console.log(r)
      
      this.datrequests = []
      this.datrequests = r 
      },

      getDATinfo: function( dat ){
        //console.log('socket action DAT');
        //this.DATinfo = dat;
        //console.log( this.DATinfo )
      },

  },
  methods: {
    closeDatRequest(e){
      e.preventDefault();
      this.popUpVisible = false;
    },
    newDatRequest(e){
      this.popUpVisible = true;
      e.preventDefault();

    },
    startDatRequest(e){
      e.preventDefault();
      this.requestDATinfo();
      this.popUpButtonHtml = { el: $(e.currentTarget), text: $(e.currentTarget).html() }
      $(e.currentTarget).html('<i class="fa fa-spinner fa-pulse"></i>');
    },



    soapRequest : function (url, headers, xml, timeout = 10000) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'post',
          url,
          headers,
          data: xml,
          timeout,        
        validateStatus: (status) => {
          return true;
        }        
        }).then((response) => {
          resolve({
            response: {
              headers: response.headers,
              body: response.data,
              statusCode: response.status,
            },
          });
        }).catch((error) => {
          console.log(error);
        });
      });
    },



    requestDATinfo: function(){

      const url = datconfig.host + '/' + datconfig.product + '/' + datconfig.service + '/VehicleIdentificationService?wsdl';
      const headers = {
        //'user-agent': 'PHP-SOAP/5.5.11\r\n',
        'productVariant': datconfig.productVariant,
        'customerLogin': datconfig.customerLogin,
        'customerNumber': datconfig.customerNumber,
        'customerSignature': datconfig.customerSignature,
        'interfacePartnerNumber': datconfig.interfacePartnerNumber,
        'interfacePartnerSignature': datconfig.interfacePartnerSignature,
        
        'Content-Type': 'text/xml;charset=UTF-8',
        'soapAction': url
      };

       var xml = "<SOAP-ENV:Envelope xmlns:SOAP-ENV=\"http://schemas.xmlsoap.org/soap/envelope/\" xmlns:ns1=\"http://sphinx.dat.de/services/VehicleIdentificationService\">"
                +"<SOAP-ENV:Body><ns1:getVehicleIdentificationByVin>"
                +"<request>"
                +   "<locale country=\"DE\" datCountryIndicator=\"DE\" language=\"de\"/>"
                +   "<restriction>APPRAISAL</restriction>"
                +   "<vin>"+this.datRequestData.vin+"</vin>" //SALDEXTESTSTUB001
                +"</request>"
                +"</ns1:getVehicleIdentificationByVin></SOAP-ENV:Body></SOAP-ENV:Envelope>";

      (async () => {
        const { response } = await this.soapRequest(url, headers, xml, 10000);     // Optional timeout parameter(milliseconds)
        const { body, statusCode } = response;

        var parser = new DOMParser(),
            xmltemp = parser.parseFromString( body ,"application/xml");

        var vehstemp = xmltemp.getElementsByTagName('ns1:Vehicle')

        if( vehstemp.length == 1 )
        var vehtemp = this.xmlToJson(  vehstemp[0] );

        else if( vehstemp.length > 1 ) {
          swal('Fehler', 'Baujahr stimmt nicht' , 'warning');
          console.log( vehstemp  );
          return false;
        }

        if( statusCode != 200 ) {
          swal('Fehler Abfrage 1', xmltemp.getElementsByTagName('faultcode')[0].textContent + " / " + xmltemp.getElementsByTagName('faultstring')[0].textContent , 'warning');
           console.log(xml);
           this.popUpVisible = false;
           return false;
        }


        //console.log( vehtemp );

        var vehicleTemp = {
          DatECode : vehtemp.DatECode.value,
          ConstructionTime : vehtemp.ConstructionTime.value,
          Container : vehtemp.Container.value,
          SpecialEquipment : vehtemp.Equipment.SpecialEquipment ? vehtemp.Equipment.SpecialEquipment.EquipmentPosition : [],
          kbaNumbers: function(){ return vehtemp.kbaNumbers ? vehtemp.kbaNumbers.value : vehtemp.kbaNumbersN.kbaNumbers.join(', ') },
          colors: []
        }

        if( vehtemp.VINResult && vehtemp.VINResult.VINColors && vehtemp.VINResult.VINColors.VINColor )

          if(  Array.isArray( vehtemp.VINResult.VINColors.VINColor ) )
            vehtemp.VINResult.VINColors.VINColor.forEach(function( item, index, arr ){
              console.log( item );
              //vehicleTemp.colors.push( item.Description.value )
            })
          else
            vehicleTemp.colors.push(  vehtemp.VINResult.VINColors.VINColor.Description.value )

        vehtemp = null
        vehstemp = null
        
        this.getEvaluation( vehicleTemp );
        
      })();      
      
    },



    getEvaluation: function( vehicleTemp ){

        var SpecialEquipment = [];
        vehicleTemp.SpecialEquipment.forEach( function( item ){
          SpecialEquipment.push( '<vxs:EquipmentPosition><vxs:DatEquipmentId>'+item.DatEquipmentId.value+'</vxs:DatEquipmentId></vxs:EquipmentPosition>' )
        })

         var xml2 = "<soapenv:Envelope xmlns:soapenv=\"http://schemas.xmlsoap.org/soap/envelope/\" "
                  + "xmlns:val=\"http://www.dat.eu/myClaim/soap/v2/ValuationService\" xmlns:vxs=\"http://www.dat.de/vxs\">"
                  + "<soapenv:Header/>"
                  + "<soapenv:Body>"
                  +   "<val:createValuation>"
                  +   "<!-- mandatory dossier -->"
                  +   "<vxs:Dossier overwrite=\"true\">"
                  +   "<!-- mandatory name of contract -->"
                  +   "<vxs:Name>" + this.datRequestData.vorgangsnummer + "</vxs:Name>"
                  +   "<!-- mandatory Language --><vxs:Language>de_DE</vxs:Language>"
                  +   "<!-- mandatory currency --><vxs:Currency>EUR</vxs:Currency>"
                  +   "<vxs:Country>DE</vxs:Country>"

                  +   "<vxs:Vehicle>"
                  +     "<!--mandatory; datECode -->"
                  +     "<vxs:DatECode>"+ vehicleTemp.DatECode +"</vxs:DatECode>"
                  +     "<!--mandatory; container --><vxs:Container>"+ vehicleTemp.Container +"</vxs:Container>"
                  +     "<!--mandatory; construction time --><vxs:ConstructionTime>" + vehicleTemp.ConstructionTime + "</vxs:ConstructionTime>"
                  +     "<!--mandatory; initial registration-->"
                  +     "<vxs:InitialRegistration>"+this.datRequestData.baujahr+"</vxs:InitialRegistration>"//"+ this.car.baujahr +"
                  +     "<!--mandatory; milage-->"
                  +     "<vxs:MileageEstimated>"+this.datRequestData.laufleistung+"</vxs:MileageEstimated>" //"+ this.car.kilometerstand +"
                  +     "<vxs:Country>DE</vxs:Country>"
                  +     "<vxs:RegistrationData>"
                  +       "<vxs:LicenseNumber>S DAT 123</vxs:LicenseNumber>"
                  +     "</vxs:RegistrationData>"

                  +     "<vxs:Equipment>"

                  +     "<!--optional; special equipment-->"


                  + ( SpecialEquipment.length > 0 ? "<vxs:SpecialEquipment>" + SpecialEquipment.join("") + "</vxs:SpecialEquipment>" : "" )


                  +       "<!--optional; additional equipment-->"
                  +       "<vxs:AdditionalEquipment>"
                  +         "<vxs:EquipmentPosition>"
                  +           "<vxs:DatEquipmentId>98300</vxs:DatEquipmentId>"
                  +         "</vxs:EquipmentPosition>"
                  +       "</vxs:AdditionalEquipment>"

                  +     "</vxs:Equipment>"
                  +     "</vxs:Vehicle>"
                
                  +      "<vxs:VAT><vxs:VatType>difference</vxs:VatType></vxs:VAT>"

                  +      "<vxs:Valuation>"
                  
                  
                  +       "<!--optional condition-->"
                  +       "<vxs:Condition>"
//                   +         "<vxs:NumberOfOwners>"+this.car.vorbesitzer+"</vxs:NumberOfOwners>"
                  +         "<vxs:AccidentDamage>accident free</vxs:AccidentDamage>"
//                   +         "<vxs:RepairCosts>500</vxs:RepairCosts>"
                  +       "</vxs:Condition>"
                  
                  +     "</vxs:Valuation>"
                  
                  +     "</vxs:Dossier>"
                  +     "<!--Id of existing contract (currently not possible)--><contractId></contractId>"
                  +     "<!-- mandatory type of contract --><contractType>bundle_valuation</contractType>"
                  +     "<!-- mandatory type of network --><networkType>DAT</networkType>"
                  +     "<!--optional data volume--><Coverage>COMPLETE</Coverage>"
                  +     "</val:createValuation>"
                  +     "</soapenv:Body>"
                  +     "</soapenv:Envelope>";


            const url2 = "http://www.dat.eu/myClaim/soap/v2/ValuationService?wsdl"; //datconfig.host + '/' + datconfig.product + '/' + datconfig.service + '/ValuationService?wsdl';

            const headers2 = {
              //'user-agent': 'PHP-SOAP/5.5.11\r\n',
              'productVariant': datconfig.productVariant,
              'customerLogin': datconfig.customerLogin,
              'customerNumber': datconfig.customerNumber,
              'customerSignature': datconfig.customerSignature,
              'interfacePartnerNumber': datconfig.interfacePartnerNumber,
              'interfacePartnerSignature': datconfig.interfacePartnerSignature,              
              'Content-Type': 'text/xml;charset=UTF-8',
              'soapAction': url2 //datconfig.host + '/' + datconfig.product + '/' + datconfig.service + '/VehicleIdentificationService?wsdl' ,
            };


            (async () => {
              const { response } = await this.soapRequest(url2, headers2, xml2, 10000); // Optional timeout parameter(milliseconds)
              const { body, statusCode } = response;

              this.proceedDATdata(body, vehicleTemp, statusCode);

            })();

    },
    proceedDATdata: function( remoteXML, vehicleTemp, statusCode ){

      var parser = new DOMParser(),
          xml = parser.parseFromString( remoteXML ,"application/xml");
      
     if( statusCode != 200 ) {
           swal('Fehler Abfrage 2', xml.getElementsByTagName('faultstring')[0].textContent , 'warning');
               console.log(xml);
               this.popUpVisible = false;
               return false;
           }
      
      var dossier = this.xmlToJson( xml.getElementsByTagName('ns1:Dossier')[0]  );

      this.DATinfo = { 
                      id: null,
                      vorgangsnummer: this.datRequestData.vorgangsnummer,
                      vin: this.datRequestData.vin,
                      baujahr: this.datRequestData.baujahr,
                      laufleistung: this.datRequestData.laufleistung,
                      data: {
                        CreateDate: {
                          title: "Datum",
                          value: dossier.CreateDate.value
                        },
                        ManufacturerName: {
                          title: "Hersteller",
                          value: dossier.Vehicle.ManufacturerName.value
                        },
                        BaseModelName: {
                          title: "Model",
                          value: dossier.Vehicle.BaseModelName.value
                        },
                        ConstructionTime: {
                          title: "Bauzeit",
                          value: dossier.Vehicle.ConstructionTime.value
                        },
                        Container: {
                          title: "Container",
                          value: dossier.Vehicle.Container.value
                        },
                        ContainerName: {
                          title: "ContainerName",
                          value: dossier.Vehicle.ContainerName.value
                        },
                        
                        SpecialEquipment: {
                          title: "AdditionalEquipment",
                          value: dossier.Vehicle.Equipment.SpecialEquipment ? dossier.Vehicle.Equipment.SpecialEquipment.EquipmentPosition : []
                        },
                        
                        SeriesEquipment: {
                          title: "Serienaussattung",
                          value: dossier.Vehicle.Equipment.SeriesEquipment.EquipmentPosition
                        },
                        DatECode: {
                          title: "DatECode",
                          value: dossier.Vehicle.DatECode.value
                        },
                        SubModelName: {
                          title: "Typ",
                          value: dossier.Vehicle.SubModelName.value
                          },
                        SalesDescription: {
                          title: "SalesDescription",
                          value: dossier.Vehicle.SalesDescription.value
                          },   
                        Leistung: {
                          title: "Leistung",
                          value: dossier.Vehicle.TechInfo.PowerKw.value + " kW / " + dossier.Vehicle.TechInfo.PowerHp.value + " PS"
                        },
                        Hubraum: {
                          title: "Hubraum",
                          value: dossier.Vehicle.TechInfo.Capacity.value + " ccm"
                        },
                        Motorart: {
                          title: "Motorart",
                          value: dossier.Vehicle.TechInfo.FuelMethod.value
                        },
                        Getriebe: {
                          title: "Getriebe",
                          value: dossier.Vehicle.TechInfo.GearboxType.value
                        },
                        Color: {
                          title: "Farbe",
                          value: vehicleTemp.colors[0]
                        },
                        SeatsDoors: {
                          title: "Sitzülätze / Türen",
                          value: dossier.Vehicle.TechInfo.VehicleSeats.value + " / " + dossier.Vehicle.TechInfo.VehicleDoors.value
                        },
                        KBA: {
                          title: "KBA-Schlüssel",
                          value: vehicleTemp.kbaNumbers
                        },
                        Mileage: {
                          title: "Laufleistung",
                          value: dossier.Vehicle.MileageEstimated.value + " km"
                        },
                        EquipmentOriginalPrice: {
                          title: "Listenpreis für Sonderausstattung",
                          value: dossier.Valuation.EquipmentOriginalPrice.value
                        },

                        OriginalPriceGross: {
                          title: "Listenpreis nach DAT",
                          value: dossier.Valuation.OriginalPriceGross.value
                        },
                        OriginalPriceGrossGesamt: {
                          title: "Listenpreis gesamt",
                          value: parseFloat(dossier.Valuation.EquipmentOriginalPrice.value) + parseFloat(dossier.Valuation.OriginalPriceGross.value)
                        },
                        
                        
                        RichtwertDAT: {
                          title: "Richtwert nach DAT",
                          value: dossier.Valuation.BasePrice.value
                        },   
                        
                        MileageCorr: {
                          title: "Laufleistungskorrektur",
                          value: dossier.Valuation.MileageCorr.value
                        },
                        ReferenceMileage: {
                          title: "Bezugslaufleistung",
                          value: dossier.Valuation.ReferenceMileage.value
                        },
                        InitialRegistrationCorr: {
                          title: "Erstzulassungskorrektur",
                          value: dossier.Valuation.InitialRegistrationCorr.value
                        },
                        BasiswertDATErmittlung: {
                          title: "Basiswert durch DAT-Ermittlung",
                          value: dossier.Valuation.BasePrice2.value
                        },
                        EquipmentPrice: {
                          title: "Gesamtwert der Ausstattungen",
                          value: dossier.Valuation.EquipmentPrice.value
                        },
                        Grundwert: {
                          title: "Grundwert durch DAT Ermittlung",
                          value: dossier.Valuation.BasePrice3.value
                        },
                        SalesPrice: {
                          title: "Händlerverkaufswert",
                          value: dossier.Valuation.SalesPrice.value
                        },
                        SalesPriceGross: {
                          title: "Händlerverkaufswert inkl. MwSt.",
                          value: dossier.Valuation.SalesPriceGross.value
                        },        
                        PurchasePriceGross: {
                          title: "Händlereinkaufswert",
                          value: dossier.Valuation.PurchasePriceGross.value
                        }                
                      }
                    }
      
      
      //console.log( JSON.stringify( this.DATinfo ));
      this.saveDATinfo();

    },
    saveDATinfo: function() {
      console.log( 'save DAT' );
      this.$socket.emit('saveDATinfo', this.DATinfo );
      //this.DATinfo.open = true;
      this.datrequests.unshift({ id: null, vorgangsnummer: this.datRequestData.vorgangsnummer, data: this.DATinfo, open: true })
      this.popUpVisible = false;
      $(this.popUpButtonHtml.el).html(  this.popUpButtonHtml.text );
/*
      this.datRequestData = {
            vin: null,
            baujahr: null,
            laufleistung: null,
            vorgangsnummer: 'xxxxxxxxxx'
          }
*/
      
    },

    xmlToJson: function(xml) {

          var obj = {};
          
          if (xml.nodeType == 1) { // element
            // do attributes
            if (xml.attributes.length > 100) {
              obj["@attributes"] = {};
                for (var j = 0; j < xml.attributes.length; j++) {
                  var attribute = xml.attributes.item(j);
                  obj["@attributes"][attribute.nodeName] = attribute.nodeValue;
                }
              }
            } else if (xml.nodeType == 3) { // text
              obj = xml.nodeValue;
            }
          
            // do children
            if (xml.hasChildNodes()) {
              for(var i = 0; i < xml.childNodes.length; i++) {
                var item = xml.childNodes.item(i);
                var nN = item.nodeName.split(':');
                var nodeName = (nN.length > 1 ? nN[1] : item.nodeName );
                //console.log(nodeName);
                if( nodeName == '#text' ) nodeName = 'value';
                if (typeof(obj[nodeName]) == "undefined") {
                  obj[nodeName] = this.xmlToJson(item);
                } else {
                  if (typeof(obj[nodeName].push) == "undefined") {
                    var old = obj[nodeName];
                    //console.log( 'ALT' + old );
                    obj[nodeName] = [];
                    obj[nodeName].push(old);
                  }
                obj[nodeName].push(this.xmlToJson(item));
                }
              }
            }
            return obj;
      }


  },

  mounted: function(){
    this.$socket.emit('getDatFastList');
  }
}
</script>
<style>
  #datFastRequestPopUp { position: fixed; top: 0em; right: 0; bottom: 0em; left: 0; background: rgba(0,0,0,0.3); display: flex; justify-content: center; align-items: center; align-content: center; z-index: 10009 }
  #datFastRequestPopUp { display: none; }
  .datFastRequestPopUpBox { opacity: 0; transition: opacity 0.5s ease; }
  
  #datFastRequestPopUp.visible { display: flex; }
  #datFastRequestPopUp.visible .datFastRequestPopUpBox { opacity: 1; transition: opacity 0.5s ease; }
  
  .datFastRequestPopUpBox { background: #fff; width: 30em; max-width: 90vw; padding: 2.7933333em; border-radius: 3px; box-shadow: 0 0 12px rgba(0,0,0,0.6); }
  .datFastRequestPopUpBox .popUp-inputwrapper { padding: 0; }
  .datFastRequestPopUpBox .button { margin: 0.93333em 0.93333em 0 0 !important; width: 45% !important; min-width: 20%; max-width: 45% !important; }
  .datFastRequestPopUpBox h3 { margin: 0 0 0.933333em 0;  }
  

</style>